import React from 'react'

export default function IncidentLogs() {
  return (
    <div>IncidentLogs</div>
  )
}
